// import React, { useEffect, useState, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getMeetingList } from "../../Redux/Actions/meetingAction";
// import { getEnums } from "../../Redux/Actions/enumsActions";
// import TableComponent from "../../Global Functions/tableComponents";
// import { Badge, Button, Dropdown, Menu } from "antd";
// import { Link } from "react-router-dom";
// import { EllipsisOutlined } from "@ant-design/icons";
// import { ToFirstCapital } from "../../Utils/helpers";

// const ListMeetings = () => {
//   const dispatch = useDispatch();
//   const { meetings } = useSelector((state) => state.meetings);
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });

//   // Fetch enums on mount
//   useEffect(() => {
//     dispatch(getEnums());
//   }, [dispatch]);

//   // Fetch meetings list on pagination change
//   const fetchDetails = useCallback(
//     (page, limit) => {
//       dispatch(getMeetingList({ page, limit }));
//     },
//     [dispatch]
//   );

//   useEffect(() => {
//     fetchDetails(pagination.current, pagination.pageSize);
//   }, [fetchDetails, pagination.current, pagination.pageSize]);

//   // Update pagination total from backend count
//   useEffect(() => {
//     if (meetings?.data?.count) {
//       setPagination((prev) => ({
//         ...prev,
//         total: meetings.data.count, // total items for pagination
//       }));
//     }
//   }, [meetings]);

//   // Defensive mapping on data array
//   const meetingArray = Array.isArray(meetings?.data?.data)
//     ? meetings.data.data
//     : [];

//   const dataSource = meetingArray.map((item, idx) => ({
//     key: item._id,
//     index: idx + 1,
//     meeting_id: item.meeting_id,
//     purpose_for_meeting: item.purpose_for_meeting,
//     meeting_date: item.meeting_date?.split("T")[0] || "",
//     meeting_time: item.time || "",
//     user_name: item.user?.name || "No Data",
//     user_email: item.user?.email || "No Data",
//     user_contact: `${item.user?.country_code || ""} ${item.user?.contact_number || ""}`.trim(),
//     status: ToFirstCapital(item.status),
//     guests:
//       Array.isArray(item.guests) && item.guests.length > 0
//         ? item.guests.map((g) => g.email).join(", ")
//         : "No Data",
//     slot: item.slot,
//     note: item.note || "No Data",
//   }));

//   const columns = [
//     {
//       title: "Sr No.",
//       align: "center",
//       render: (_, __, index) => index + 1,
//     },
//     {
//       title: "Meeting ID",
//       dataIndex: "meeting_id",
//       key: "meeting_id",
//       align: "center",
//     },
//     {
//       title: "Purpose for Meeting",
//       dataIndex: "purpose_for_meeting",
//       key: "purpose_for_meeting",
//       align: "center",
//       ellipsis: true,
//     },
//     {
//       title: "Meeting Date",
//       dataIndex: "meeting_date",
//       key: "meeting_date",
//       align: "center",
//     },
//     {
//       title: "Meeting Time",
//       dataIndex: "meeting_time",
//       key: "meeting_time",
//       align: "center",
//     },
//     {
//       title: "Slot",
//       dataIndex: "slot",
//       key: "slot",
//       align: "center",
//     },
//     // {
//     //   title: "Note",
//     //   dataIndex: "note",
//     //   key: "note",
//     //   align: "center",
//     //   ellipsis: true,
//     // },
//     {
//       title: "User Name",
//       dataIndex: "user_name",
//       key: "user_name",
//       align: "center",
//     },
//     {
//       title: "User Email",
//       dataIndex: "user_email",
//       key: "user_email",
//       align: "center",
//     },
//     {
//       title: "Contact Number",
//       dataIndex: "user_contact",
//       key: "user_contact",
//       align: "center",
//     },
//     // {
//     //   title: "Guests",
//     //   dataIndex: "guests",
//     //   key: "guests",
//     //   align: "center",
//     //   ellipsis: true,
//     // },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       align: "center",
//       render: status => (
//         <span style={{
//           display: "inline-flex",
//           alignItems: "center",
//           padding: "4px 8px",
//           border: "1px solid #d9d9d9",
//           borderRadius: "10px",
//         }}>
//           <Badge color={status === "Requested" ? "orange" : "green"} text={status} />
//         </span>
//       ),
//     },
//     {
//       title: "Action",
//       align: "center",
//       render: (_, record) => (
//         <Dropdown
//           trigger={["click"]}
//           overlay={
//             <Menu>
//               <Link to={`/meeting/view-meeting/${record.key}`}>
//                 <Menu.Item key="view">View</Menu.Item>
//               </Link>
//             </Menu>
//           }
//         >
//           <Button shape="square" icon={<EllipsisOutlined />} />
//         </Dropdown>
//       ),
//     },
//   ];

//   // Handle Table pagination change
//   const handleTableChange = (newPagination) => {
//     setPagination(newPagination);
//     fetchDetails(newPagination.current, newPagination.pageSize);
//   };

//   const filterHandler = () => {
//     setPagination(prev => ({ ...prev, current: 1 }));
//     fetchDetails(1, pagination.pageSize);
//   };

//   return (
//     <TableComponent
//       h3heading="Meetings List"
//       filterFunction={filterHandler}
//       pagination={{
//         current: pagination.current,
//         pageSize: pagination.pageSize,
//         total: pagination.total,
//         showSizeChanger: true,
//         showQuickJumper: true,
//       }}
//       dataSource={dataSource}
//       onChange={handleTableChange}
//       columns={columns}
//       setState={setPagination}
//     />
//   );
// };

// export default ListMeetings;

import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./listMeetings.css";
import CategoriesDropdown from "./categoriesDropdown";
import MeetingsCalendar from "./meetingsCalender";
import SmallCalendar from "./smallCalendar";
import { useDispatch, useSelector } from "react-redux";
import { getMeetingList } from "../../Redux/Actions/meetingAction";
import axios from "axios";
import toast from "react-hot-toast";
import { viewTeamMembersListNoPagination } from "../../Redux/Actions/teamMembersAction";
import { getEnums } from "../../Redux/Actions/enumsActions";

const ListMeetings = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [isOpen, setIsOpen] = useState(false);
  const [eventsProp, setEventsProp] = useState([]);
  const categories = ["Team Meeting", "Customer Meeting", "Re-Scheduled"];
  const myMeetings = ["Scheduled", "Re-Scheduled", "Cancel"];
  const label = "My Meetings";

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });

  const dispatch = useDispatch();

  const fetchDetails = (page, limit) => {
    dispatch(getMeetingList({ page, limit }));
    dispatch(viewTeamMembersListNoPagination({ role: "business_manager" }));
  };

  useEffect(() => {
    dispatch(getEnums());
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { meetings } = useSelector((state) => state.meetings || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { teamMembers } = useSelector((state) => state.teamMembers);

  useEffect(() => {
    console.log("Fetched meetings data:", meetings);
  }, [meetings]);
  useEffect(() => {
    if (meetings?.total) {
      setPagination((prev) => ({ ...prev, total: meetings.total }));
    }
  }, [meetings]);

  const [selectedMeeting, setSelectedMeeting] = useState({});

  const meetingStatus = enumsData?.data?.meetingStatus
    ? Object.values(enumsData.data.meetingStatus).map((v) => v)
    : [];

  const [meetingApiPayload, setMeetingApiPayload] = useState({
    meeting_id: "",
    meeting_link: "",
    business_manager: "",
    status: "",
    time: "",
  });

  const addMeetingPopupHandler = () => {
    setIsOpen(!isOpen);
  };

  const parseTime = (timeStr) => {
    const time = timeStr.slice(0, 5);
    const modifier = timeStr.slice(5).toUpperCase();
    let [hours, minutes] = time.split(":").map(Number);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    return { hours, minutes };
  };

  const formatEventStart = (dateStr, timeStr) => {
    const date = new Date(dateStr);
    if (!timeStr) return date;
    const { hours, minutes } = parseTime(timeStr);
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  useEffect(() => {
    const formattedEvents = meetings?.data?.data?.map((meeting) => ({
      title:
        meeting.purpose_for_meeting.charAt(0).toUpperCase() +
        meeting.purpose_for_meeting.slice(1) || "Meeting",
      id: meeting._id,
      link: meeting.meeting_link || "Add Link",
      start: formatEventStart(meeting.meeting_date, meeting.time),
      end: meeting.endDate
        ? new Date(meeting.endDate)
        : new Date(
          formatEventStart(meeting.meeting_date, meeting.time).getTime() +
          60 * 30 * 1000
        ),
      time: meeting.time,
    }));
    setEventsProp(formattedEvents);
  }, [meetings]);

  const clickedMeeting = (event) => {
    try {
      const meetingId = event.id;
      if (meetingId) {
        const found = Array.isArray(meetings?.data?.data)
          ? meetings.data.data.find((m) => m._id === meetingId)
          : null;
        if (!found) return;

        setSelectedMeeting(found);

        setMeetingApiPayload({
          meeting_id: found._id,
          meeting_link: found.meeting_link || "",
          business_manager: found.business_manager || "",
          status: found.status || "",
          time: found.time || "",
        });

        addMeetingPopupHandler();
      }
    } catch (err) {
      console.error("Meeting Not Found");
    }
  };

  const addMeetingLinkHandler = async () => {
    if (!meetingApiPayload.business_manager) {
      toast.error("Please Assign Business Manager!!");
      return;
    }
    if (!meetingApiPayload.meeting_link) {
      toast.error("Please  Give Meeting Link!!");
      return;
    }

    try {
      const nonEmptyPayload = Object.fromEntries(
        Object.entries(meetingApiPayload).filter(
          ([_, v]) => v !== "" && v !== null && v !== undefined
        )
      );

      await axios.post(`${BASE_URL}/meeting/update`, nonEmptyPayload, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Meeting updated successfully");
      setIsOpen(false);
      fetchDetails(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error("Error while updating meeting", error);
      toast.error("Failed to update meeting");
    }
  };

  return (
    <MainLayout>
      <div
        className="calendar"
        style={{
          gridColumn: "2/6",
          background: "white",
          borderRadius: "25px",
          marginRight: "10px",
        }}
      >
        <MeetingsCalendar onSelectEvent={clickedMeeting} events={eventsProp} />
      </div>
      <div>
        {/* <button onClick={addMeetingPopupHandler} className="create_meeting">
          <span style={{ padding: "10px" }}>+</span>
          Update Meeting
        </button> */}
        <SmallCalendar />
        <CategoriesDropdown label={label} categories={myMeetings} />
        <CategoriesDropdown
          label="Categories"
          categories={categories}
          showColorSquares={true}
        />
      </div>
      {isOpen && (
        <div className="popup-overlay">
          <div className="meeting_popup">
            <span className="create-meeitng-span">Update Meeting</span>
            <div style={{ gridColumn: "span 2" }}>
              <span className="span-class-meet">Meeting Link</span>
              <input
                type="text"
                className="input-class-meet"
                value={meetingApiPayload.meeting_link}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.trim() === "") {
                    toast.error("Meeting Link cannot be empty");
                  }
                  setMeetingApiPayload((prev) => ({
                    ...prev,
                    meeting_link: value,
                  }));
                }}
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Builder Name</span>
              <input
                value={selectedMeeting?.builder?.brand_name || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Builder Email</span>
              <input
                value={selectedMeeting?.builder?.primary_email || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">User Name</span>
              <input
                value={selectedMeeting?.user?.name || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">User Email</span>
              <input
                value={selectedMeeting?.user?.email || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Purpose for Meeting</span>
              <input
                value={selectedMeeting?.purpose_for_meeting || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Note</span>
              <input
                value={selectedMeeting?.note || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Guests</span>
              <input
                id="guestEmail"
                name="guestEmail"
                disabled
                type="text"
                className="input-class-meet"
                value={
                  selectedMeeting?.guests && selectedMeeting.guests.length > 0
                    ? selectedMeeting.guests
                      .map((guest) => guest.email)
                      .join(", ")
                    : "No Data"
                }
              />
            </div>

            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Add Business Manager</span>
              <div className="custom-select-wrapper">
                <select
                  className="input-class-meet"
                  name="businessManager"
                  id="business-manager-meeting"
                  value={meetingApiPayload.business_manager}
                  onChange={(e) =>
                    setMeetingApiPayload((prev) => ({
                      ...prev,
                      business_manager: e.target.value,
                    }))
                  }
                >
                  <option disabled value="">
                    Select an Option
                  </option>
                  {Array.isArray(teamMembers?.data) &&
                    teamMembers.data.map((member) => (
                      <option key={member._id} value={member._id}>
                        {member.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Project Name</span>
              <input
                value={selectedMeeting?.project?.project_name || "No Data"}
                type="text"
                disabled
                className="input-class-meet"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Date</span>
              <input
                type="text"
                disabled
                className="input-class-meet"
                value={
                  selectedMeeting?.meeting_date
                    ? new Date(
                      selectedMeeting.meeting_date
                    ).toLocaleDateString()
                    : "No Data"
                }
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Meeting Slots</span>
              <input
                type="text"
                disabled
                value={selectedMeeting?.slot || "No Data"}
                className="input-class-meet"
              />
            </div>
            {meetingApiPayload?.status === "rescheduled" ? (
              <div style={{ gridColumn: "span 1" }}>
                <span className="span-class-meet">Meeting Time</span>
                <input
                  type="time"
                  className="input-class-meet"
                  name="time"
                  value={meetingApiPayload.time}
                  onChange={(e) =>
                    setMeetingApiPayload((prev) => ({
                      ...prev,
                      time: e.target.value,
                    }))
                  }
                />
              </div>
            ) : (
              <div style={{ gridColumn: "span 1" }}>
                <span className="span-class-meet">Meeting Time</span>
                <input
                  type="text"
                  className="input-class-meet"
                  disabled
                  value={selectedMeeting?.time || "No Data"}
                />
              </div>
            )}
            <div style={{ gridColumn: "span 1" }}>
              <span className="span-class-meet">Meeting Status</span>
              <div className="custom-select-wrapper">
                <select
                  className="input-class-meet"
                  value={meetingApiPayload.status}
                  onChange={(e) =>
                    setMeetingApiPayload((prev) => ({
                      ...prev,
                      status: e.target.value,
                    }))
                  }
                >
                  <option disabled value="">
                    Select an Option
                  </option>
                  {Array.isArray(meetingStatus)
                    ? meetingStatus.map((item, idx) => (
                      <option value={item} key={idx}>
                        {item.charAt(0).toUpperCase() + item.slice(1)}
                      </option>
                    ))
                    : []}
                </select>
              </div>
            </div>
            <div style={{display: "flex"}}>
            <button style={{width: "50%"}} onClick={addMeetingPopupHandler}>Cancel</button>
            <button style={{width: "50%"}} onClick={addMeetingLinkHandler}>Update</button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ListMeetings;
